import { render, staticRenderFns } from "./GenericConfirmationDialog.vue?vue&type=template&id=3ec127b4&scoped=true&"
import script from "./GenericConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./GenericConfirmationDialog.vue?vue&type=script&lang=js&"
import style0 from "./GenericConfirmationDialog.vue?vue&type=style&index=0&id=3ec127b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec127b4",
  null
  
)

export default component.exports